import { computed } from 'vue'

import type { ApplicationAdditionRequest } from '@/services/application'
import { useApplicationContext } from '../../application.context'

export const useApplicationAdditions = () => {
  const { application, isLoading, error } = useApplicationContext()

  const applicationAdditionRequests = computed<ApplicationAdditionRequest[]>(() => {
    return application.value?.openApplicationAdditionRequests ?? []
  })

  return {
    application,
    applicationAdditionRequests,
    isLoading,
    error,
  }
}
